module.exports = __webpack_public_path__ + "img/18.fd88546e.gif";